module.exports = __webpack_public_path__ + "img/047ab1b.svg";